import OrganizationDevicesController from './organization-devices.controller';
import template from './organization-devices.html';

export default {
    controller: OrganizationDevicesController,
    template
};
